module.exports = __webpack_public_path__ + "img/pictures.bd3cdfde.svg";